import { GridColDef } from "@mui/x-data-grid";
import ExternalLinkAnchor from "../../common/ExternalLinkAnchor";
import FormattedCountryCell from "../../client/client-list/FormattedCountryCell";

const dateFormatter = (timestamp: number | string | undefined): string => {
  return timestamp ? new Date(timestamp).toLocaleDateString("en-GB") : "";
};

const columns = (displaySold: string): GridColDef[] => {
  const baseColumns: GridColDef[] = [
    {
      field: "project",
      headerName: "Project",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "projectTotalArea",
      headerName: "Project Total Area",
      minWidth: 145,
      flex: 1,
    },
    {
      field: "unitSerialNumber",
      headerName: "Serial No.",
      minWidth: 90,
      flex: 1,
    },
    {
      field: "individualUnitArea",
      headerName: "Individual Unit Area",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "logo",
      headerName: "Logo",
      minWidth: 70,
      flex: 1,
      renderCell: (params) => (
        <img
          src={
            params.row.logoUrl ||
            "https://images.pexels.com/photos/165537/pexels-photo-165537.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          }
          alt="logo"
          style={{ width: "auto", height: "30px" }}
        />
      ),
    },
    {
      field: "whatThreeWordsPoint",
      headerName: "W3W Reference",
      minWidth: 140,
      flex: 1,
    },
    {
      field: "public",
      headerName: "Public",
      minWidth: 70,
      flex: 1,
      type: "boolean",
      valueGetter: (_, row) => row.public?.isPublic || false,
      renderCell: (params) => {
        if (params.row.public && params.row.public.isPublic) {
          return (
            <ExternalLinkAnchor
              url={params.row.public.url}
              dataTestid={`public-url-anchor-${params.row.id}`}
            />
          );
        }
        return "public";
      },
    },
    {
      field: "country",
      headerName: "Country",
      minWidth: 120,
      flex: 1,
      valueGetter: (_, row) => {
        if (!row.country) {
          return null;
        }
        return row.country.name;
      },
      renderCell: (params) => (
        <FormattedCountryCell country={params.row.country} />
      ),
    },
  ];

  if (displaySold !== "unsold units") {
    baseColumns.push(
      {
        field: "soldDate",
        headerName: "Sold Date",
        minWidth: 100,
        flex: 1,
        renderCell: (params) => dateFormatter(params.row.soldDate),
      },
      {
        field: "client",
        headerName: "Client",
        minWidth: 140,
        flex: 1,
      },
      {
        field: "clientId",
        headerName: "Client Id",
        minWidth: 140,
        flex: 1,
      },
      {
        field: "edgeOrFullBoxArea",
        headerName: "Edge/Full",
        minWidth: 140,
        flex: 1,
      },
    );
  }

  return baseColumns;
};

export default columns;
